export const currency = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
});

export const today = '2026-05-12';

export const inventoryData = {
    items: [
        {
            id: 1,
            image: '🍗',
            name: 'Chicken Breast',
            category: 'Raw',
            type: 'Meat',
            unit: 'Kg',
            openingStock: 50,
            currentStock: 12,
            usedToday: 8,
            wastage: 1,
            threshold: 15,
            supplier: 'Fresh Foods',
            status: 'Available',
            lastPurchase: { qty: '20 Kg', amount: 4500, date: '12 May 2026' },
        },
        {
            id: 2,
            image: '🍅',
            name: 'Tomato',
            category: 'Raw',
            type: 'Vegetable',
            unit: 'Kg',
            openingStock: 35,
            currentStock: 2,
            usedToday: 5,
            wastage: .5,
            threshold: 8,
            supplier: 'Fresh Foods',
            status: 'Low Stock',
            lastPurchase: { qty: '25 Kg', amount: 1250, date: '10 May 2026' },
        },
        {
            id: 3,
            image: '🧀',
            name: 'Cheese',
            category: 'Kitchen',
            type: 'Dairy',
            unit: 'Box',
            openingStock: 8,
            currentStock: 1,
            usedToday: 1,
            wastage: 0,
            threshold: 3,
            supplier: 'Dairy Hub',
            status: 'Low Stock',
            lastPurchase: { qty: '6 Box', amount: 3600, date: '09 May 2026' },
        },
        {
            id: 4,
            image: '🍚',
            name: 'Rice',
            category: 'Kitchen',
            type: 'Grain',
            unit: 'Kg',
            openingStock: 80,
            currentStock: 46,
            usedToday: 12,
            wastage: .2,
            threshold: 20,
            supplier: 'Grain Cart',
            status: 'Available',
            lastPurchase: { qty: '50 Kg', amount: 4300, date: '08 May 2026' },
        },
        {
            id: 5,
            image: '🍺',
            name: 'Soda Bottle',
            category: 'Bar',
            type: 'Beverage',
            unit: 'Pcs',
            openingStock: 120,
            currentStock: 0,
            usedToday: 18,
            wastage: 0,
            threshold: 25,
            supplier: 'Beverage Line',
            status: 'Out of Stock',
            lastPurchase: { qty: '120 Pcs', amount: 3000, date: '05 May 2026' },
        },
    ],
    suppliers: [
        { id: 1, name: 'Fresh Foods', contact: '9847000411', pending: 12000, lastOrder: 'May 10' },
        { id: 2, name: 'Dairy Hub', contact: '9847000522', pending: 6800, lastOrder: 'May 09' },
        { id: 3, name: 'Grain Cart', contact: '9847000633', pending: 4200, lastOrder: 'May 08' },
    ],
    weeklyConsumption: [
        ['Mon', 42],
        ['Tue', 58],
        ['Wed', 45],
        ['Thu', 72],
        ['Fri', 64],
        ['Sat', 88],
        ['Sun', 54],
    ],
    recipes: [
        { name: 'Chicken Fried Rice', ingredients: [['Rice', '200 gm'], ['Chicken', '150 gm'], ['Oil', '20 ml']], autoDeduct: true },
        { name: 'Cheese Tomato Sandwich', ingredients: [['Cheese', '1 Slice'], ['Tomato', '80 gm'], ['Bread', '2 Pcs']], autoDeduct: true },
    ],
};
